export const reservationPaths = {
  RESERVATION_LIST: "",
  RESERVATION_VIEW: ":id",
  RESERVATION_ID: (id) => `${id}/overview`,
  RESERVATION_OVERVIEW: ":id/overview",
  RESERVATION_OVERVIEW_NAV: (id) => `${id}/overview`,
  RESERVATION_ORDERS: ":id/orders",
  RESERVATION_ORDERS_NAV: (id) => `${id}/orders`,
  RESERVATION_BILLING: ":id/billing",
  RESERVATION_BILLING_NAV: (id) => `${id}/billing`,
};
